/* eslint-disable no-unused-vars */
import api from '@/store/Api'

const dataLayer = {
  getAllSpieces: () => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetAllSpecies')
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetFeaturedSpecies: () => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetFeaturedSpecies')
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetSubCategories: () => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetSubCategories')
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetFacts: () => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetFacts')
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetSpecGeo: () => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetSpecGeo')
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  InWhatLan: (lat, lng) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/LivetMisc/Livet/InWhatLan/${lat}/${lng}`)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetSpecEnv: () => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetSpecEnv')
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  prefetchPage: id => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetItemsInPageById/' + id)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  }
}
export default dataLayer
